"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscrowFetcher = void 0;
const fetcher_1 = require("./fetcher");
const types_1 = require("../types");
const anchor_1 = require("@project-serum/anchor");
const __1 = require("..");
class EscrowFetcher {
    constructor(connection, pda, cache) {
        this.fetcher = new fetcher_1.AccountFetcher(connection, cache);
        this.pda = pda;
        this.connection = connection;
    }
    getConfigData() {
        return __awaiter(this, void 0, void 0, function* () {
            const configPDA = this.pda.getConfigPDA();
            return yield this.fetcher.getEscrowConfig(configPDA.key);
        });
    }
    getTradeOrder(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const tradeOrderPDA = this.pda.getTradeOrderPDA(orderId);
            return yield this.fetcher.getTradeOrderData(tradeOrderPDA.key);
        });
    }
    getTradesByStatus(tradeStatus) {
        return __awaiter(this, void 0, void 0, function* () {
            const allTrades = yield this.connection.getProgramAccounts(this.pda.programId, {
                filters: [
                    {
                        dataSize: types_1.TRADE_ORDER_SIZE,
                    },
                    {
                        memcmp: {
                            offset: (0, __1.getTradeStateOffSet)(),
                            bytes: (0, __1.mapTradeStateToByte)(tradeStatus),
                        },
                    },
                ],
            });
            let parsedTrades = [];
            for (let trade of allTrades) {
                let value = __1.ParsableTradeOrder.parse(trade.account.data);
                parsedTrades.push(value);
            }
            return parsedTrades;
        });
    }
    getTradesByBuyerAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const allTrades = yield this.connection.getProgramAccounts(this.pda.programId, {
                filters: [
                    {
                        dataSize: types_1.TRADE_ORDER_SIZE,
                    },
                    {
                        memcmp: {
                            offset: (0, __1.getTradeBuyerAddressOffset)(),
                            bytes: address.toBase58(),
                        },
                    },
                ],
            });
            let parsedTrades = [];
            for (let trade of allTrades) {
                let value = __1.ParsableTradeOrder.parse(trade.account.data);
                parsedTrades.push(value);
            }
            return parsedTrades;
        });
    }
    getTradesBySellerAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const allTrades = yield this.connection.getProgramAccounts(this.pda.programId, {
                filters: [
                    {
                        dataSize: types_1.TRADE_ORDER_SIZE,
                    },
                    {
                        memcmp: {
                            offset: (0, __1.getTradeSellerAddressOffset)(),
                            bytes: address.toBase58(),
                        },
                    },
                ],
            });
            let parsedTrades = [];
            for (let trade of allTrades) {
                let value = __1.ParsableTradeOrder.parse(trade.account.data);
                parsedTrades.push(value);
            }
            return parsedTrades;
        });
    }
    getTradeOrders(startOrderId, endOrderId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetcher.refreshAll();
            const configData = yield this.getConfigData();
            if (!configData) {
                throw new Error("Config data not found");
            }
            let currentId = configData.currentId.toNumber();
            if (endOrderId) {
                if (endOrderId < currentId) {
                    currentId = endOrderId;
                }
            }
            if (startOrderId >= currentId) {
                throw new Error("Invalid startOrderId");
            }
            const orderPubkeys = [];
            for (let i = startOrderId; i < currentId; i++) {
                orderPubkeys.push(this.pda.getTradeOrderPDA(new anchor_1.BN(i)).key);
            }
            return yield this.fetcher.getTradeOrderDatas(orderPubkeys);
        });
    }
    getAllTradeOrders() {
        return __awaiter(this, void 0, void 0, function* () {
            const configData = yield this.getConfigData();
            if (!configData) {
                throw new Error("Config data not found");
            }
            const currentId = configData.currentId.toNumber();
            const orderPubkeys = [];
            for (let i = 1; i < currentId; i++) {
                orderPubkeys.push(this.pda.getTradeOrderPDA(new anchor_1.BN(i)).key);
            }
            return yield this.fetcher.getTradeOrderDatas(orderPubkeys);
        });
    }
    getKYCCertData(userPubkey) {
        return __awaiter(this, void 0, void 0, function* () {
            const kycCertPDA = this.pda.getKycCertPDA(userPubkey);
            return yield this.fetcher.getKycCertData(kycCertPDA.key);
        });
    }
    getTokenInfoData(tokenMint) {
        return __awaiter(this, void 0, void 0, function* () {
            const tokenInfoPDA = this.pda.getTokenInfoPDA(tokenMint);
            return yield this.fetcher.getTokenInfoData(tokenInfoPDA.key);
        });
    }
    isArbitrator(userPubkey) {
        return __awaiter(this, void 0, void 0, function* () {
            const arbitratorCertPDA = this.pda.getArbitratorCertPDA(userPubkey);
            const arbiratorData = yield this.fetcher.getArbitratorCertData(arbitratorCertPDA.key);
            return arbiratorData != null;
        });
    }
    refreshAll() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetcher.refreshAll();
        });
    }
}
exports.EscrowFetcher = EscrowFetcher;
